export const displayCurrency = (amount: number, decimalPlaces = 2) => {
  const currencyFormat = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    maximumFractionDigits: decimalPlaces,
  });
  return currencyFormat.format(amount);
};
